// src/components/NotFound.jsx

// Import React to use JSX and component functionality
import React from 'react';
// Import Link from react-router-dom for client-side navigation
import { Link } from 'react-router-dom';

// Functional component to display a 404 page
const NotFound = () => {
  return (
    // Main container centered with padding
    <div className="text-center p-10">
      {/* Large 404 error text */}
      <h1 className="text-5xl font-bold text-red-600">404</h1>

      {/* Informative message about missing page */}
      <p className="text-lg mt-4">
        Oops! The page you’re looking for doesn’t exist.
      </p>

      {/* Link to redirect user back to homepage */}
      <Link
        to="/" // Route to homepage
        className="text-blue-800 hover:underline mt-4 inline-block"
      >
        Go Back Home
      </Link>
    </div>
  );
};

// Export the component for usage in routing or other components
export default NotFound;
